export const getLoginUrl = () => {
    const stage = process.env.STAGE;

    if (stage === 'prod') {
        return 'https://app.opus1.io/login';
    }

    if (stage === 'local') {
        return 'https://opus1music.opus1local.io:3000/login';
    }

    return `https://opus1music.opus1${stage}.io/login`;
};

export const getMainAppUrl = (businessName) => {
    const stage = process.env.STAGE;

    if (stage === 'local') {
        return `https://${businessName}.opus1local.io:3000`;
    }

    if (stage === 'prod') {
        return `https://${businessName}.opus1.io`;
    }

    return `https://${businessName}.opus1${stage}.io`;
};

export const getAppUrl = () => {
    const stage = process.env.STAGE;

    if (stage === 'local') {
        return 'https://app.opus1local.io:3000';
    }

    if (stage === 'prod') {
        return 'https://app.opus1.io';
    }

    return `https://app.opus1${stage}.io`;
};

export const getAllStaffPageUrl = (businessName) =>
    `${getMainAppUrl(businessName)}/staff`;

export const getStaffMultiEditorPageUrl = (
    businessName,
    runId,
    expectedCount,
) => {
    const params = new URLSearchParams({
        run_id: runId,
        expected_count: String(expectedCount),
    });
    return `${getMainAppUrl(businessName)}/staff-multi-editor?${params.toString()}`;
};
